import { useAtom } from '@reatom/npm-react'
import { Link, useLocation } from 'react-router'
import styled from 'styled-components'

import { Copy3ReversedIcon } from '@blade/ui-kit'
import { reatomPair } from '@root/entities/pair/atoms'
import { PairPopover } from '@root/features/pair'
import { clipboardPairAtom } from '@root/features/pair/atoms/reatom-clipboard-pair'
import { TradeRoute } from '@root/features/routing'
import { tradingPairAtom } from '@root/features/trade/trading/atoms'

import { IconButton } from './topbar-common'

export const TopbarClipboardPair: React.FC = () => {
  const location = useLocation()

  const [clipboardPair] = useAtom(
    (ctx) => {
      const clipboardPair = ctx.spy(clipboardPairAtom)
      if (!clipboardPair) {
        return undefined
      }
      const tradingPair = ctx.spy(tradingPairAtom)
      if (!tradingPair) {
        return clipboardPair
      }
      const isTradePage = TradeRoute.match(location.pathname)
      if (!isTradePage) {
        return clipboardPair
      }
      if (reatomPair.eqByAddress(clipboardPair, tradingPair)) {
        return undefined
      }
      return clipboardPair
    },
    [location],
  )

  if (!clipboardPair) {
    return undefined
  }
  const route = TradeRoute.build({
    network: clipboardPair.network,
    pairAddress: clipboardPair.address,
  })

  return (
    <>
      <PairPopover sideOffset={10} pair={clipboardPair}>
        <IconButton as={Link} to={route}>
          <Copy3ReversedIcon size={16} />
        </IconButton>
      </PairPopover>
      <Separator />
    </>
  )
}

const Separator = styled.div`
  width: 1px;
  height: 16px;

  border-radius: 2px;
  background: var(--background-3);
`
